import React from 'react';

function OpticalDispensarySkeleton({ rows = 6 }) {
    return (
        <div className="optical-dispensary-skeleton" aria-hidden="true">
            {Array.from({ length: rows }).map((_, index) => (
                <div key={index} className="optical-dispensary-skeleton__row">
                    <span className="optical-dispensary-skeleton__block optical-dispensary-skeleton__block--lg" />
                    <span className="optical-dispensary-skeleton__block optical-dispensary-skeleton__block--sm" />
                    <span className="optical-dispensary-skeleton__block optical-dispensary-skeleton__block--md" />
                    <span className="optical-dispensary-skeleton__block optical-dispensary-skeleton__block--sm" />
                    <span className="optical-dispensary-skeleton__block optical-dispensary-skeleton__block--md" />
                </div>
            ))}
        </div>
    );
}

export default OpticalDispensarySkeleton;
